Vue.component('asset-settings', {});
